module.exports = __webpack_public_path__ + "img/clbj.c7142f86.png";